import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as Bixby from '$/core';
import HeadBlock from '$/components/global/heading';
import { AppState } from '$/store';
import {
  getIsCurrentUserClientState,
  getIsCurrentUserCreditSightsAnalystState,
  getIsCurrentUserCreditSightsOpsState,
  getIsCurrentUserClientComplianceAdminState,
  getIsCurrentUserSuFAnalystState,
  getIsCurrentUserRatingsAnalystState,
} from '$/store/profile/selectors';
import { getIsCurrentUserAdminState } from '$/store/profile/selectors';

import './index.scss';
import DataSitesNavigation from '../DataSitesNavigation';
import { Route, Routes } from 'react-router-dom';
import HeadingTab from '$/components/global/headingTab';
import NonMnpiDataSitesAccess from '$/pages/client/data-sites/Access/nonMnpiAccess';
import MnpiDataSitesAccess from '$/pages/client/data-sites/Access/mnpiAccess';
import { ClientService } from '$/services';
import Loading from '$/components/loading/Loading';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';

interface IAccessProps {
  isAdmin: boolean;
  isClient: boolean;
  isCreditSightsOpsSufOrRatings: boolean;
  isClientComplianceAdmin: boolean;
  isBixbyComplianceEnabled: boolean;
}

const DataSitesAccess: React.FC<IAccessProps> = props => {
  const { isAdmin, isClient, isCreditSightsOpsSufOrRatings, isClientComplianceAdmin, isBixbyComplianceEnabled } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [dataSitesError, setDataSitesError] = useState(undefined as string | undefined);
  const [dataSites, setDataSites] = useState(undefined as Bixby.Models.ClientDataSiteForClient[] | undefined);
  const [mnpiDataSites, setMnpiDataSites] = useState(undefined as Bixby.Models.ClientDataSiteForClient[] | undefined);

  const baseUrl = '/data-sites/access';

  useEffect(() => {
    const getDataSitesAsync = async () => {
      setIsLoading(true);
      setDataSitesError(undefined);
      try {
        if (isClientComplianceAdmin) {
          const mnpiDataSites: Bixby.Models.ClientDataSiteForClient[] = await ClientService.getMnpiDataSites();
          setMnpiDataSites(mnpiDataSites);
        }
        const dataSites: Bixby.Models.ClientDataSiteForClient[] = await ClientService.getDataSites();
        setDataSites(dataSites);
      } catch (e: any) {
        setDataSitesError('Error retrieving data sites');
      } finally {
        setIsLoading(false);
      }
    };

    if (isClient === true && isCreditSightsOpsSufOrRatings !== true) {
      getDataSitesAsync();
    }
  }, [isClient, isCreditSightsOpsSufOrRatings, isClientComplianceAdmin]);

  const content = isAdmin ? (
    <React.Fragment>
      <section>
        <div className="data-sites-access-section">
          <h3>Admin User</h3>
        </div>
      </section>
    </React.Fragment>
  ) : isCreditSightsOpsSufOrRatings ? (
    <React.Fragment>
      <section>
        <div className="data-sites-access-section">
          <h3>CreditSights User</h3>
        </div>
      </section>
    </React.Fragment>
  ) : isLoading && dataSites === undefined ? (
    <Loading pageLevel />
  ) : isClient ? (
    <React.Fragment>
      {!Bixby.Utils.isNullOrEmpty(dataSitesError) ? (
        <section>
          <div className="data-sites-access-note">
            <p className="error">{dataSitesError}</p>
          </div>
        </section>
      ) : !isBixbyComplianceEnabled ? (
        <section>
          <NonMnpiDataSitesAccess dataSites={dataSites} />
        </section>
      ) : (
        <section>
          <HeadBlock title={''}>
            <HeadingTab title="Client Data Sites" link={`${baseUrl}/non-mnpi`} />
            {isClientComplianceAdmin && <HeadingTab title="Mnpi Client Data Sites" link={`${baseUrl}/mnpi`} />}
          </HeadBlock>
          <div>
            <Routes>
              <Route path={'non-mnpi'} element={<NonMnpiDataSitesAccess dataSites={dataSites} />} />
              {isClientComplianceAdmin && (
                <Route path={'mnpi'} element={<MnpiDataSitesAccess dataSites={mnpiDataSites} />} />
              )}
            </Routes>
          </div>
        </section>
      )}
    </React.Fragment>
  ) : null;

  return <DataSitesNavigation>{content}</DataSitesNavigation>;
};

const mapStateToProps = (state: AppState) => {
  const { isClient } = getIsCurrentUserClientState(state);
  const { isAdmin } = getIsCurrentUserAdminState(state);
  const { isCreditSightsAnalyst } = getIsCurrentUserCreditSightsAnalystState(state);
  const { isRatingsAnalyst } = getIsCurrentUserRatingsAnalystState(state);
  const { isSuFAnalyst } = getIsCurrentUserSuFAnalystState(state);
  const { isCreditSightsOps } = getIsCurrentUserCreditSightsOpsState(state);
  const { isClientComplianceAdmin } = getIsCurrentUserClientComplianceAdminState(state);
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);

  return {
    isAdmin,
    isClient,
    isCreditSightsOpsSufOrRatings: isCreditSightsAnalyst || isCreditSightsOps || isSuFAnalyst || isRatingsAnalyst,
    isClientComplianceAdmin,
    isBixbyComplianceEnabled,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DataSitesAccess);
